export function parseFrontmatter(content: unknown) {
  // Ensure content is a string
  let contentStr = '';
  if (typeof content === 'string') {
    contentStr = content;
  } else if (content && typeof content === 'object' && 'default' in content) {
    contentStr = String(content.default);
  } else {
    contentStr = String(content);
  }

  const frontmatterRegex = /^---\n([\s\S]*?)\n---\n([\s\S]*)$/;
  const match = contentStr.match(frontmatterRegex);

  if (!match) {
    return { data: {}, content: contentStr };
  }

  const frontmatter = match[1];
  const markdown = match[2];

  const data: Record<string, any> = {};
  frontmatter.split('\n').forEach(line => {
    const [key, ...valueParts] = line.split(':');
    const value = valueParts.join(':').trim();
    if (key && value) {
      // Handle different value types
      if (value.startsWith('"') && value.endsWith('"')) {
        data[key.trim()] = value.slice(1, -1);
      } else if (value === 'true') {
        data[key.trim()] = true;
      } else if (value === 'false') {
        data[key.trim()] = false;
      } else if (value.startsWith('[')) {
        data[key.trim()] = JSON.parse(value);
      } else {
        data[key.trim()] = value;
      }
    }
  });

  return { data, content: markdown };
}
